module.exports = __webpack_public_path__ + "media/images/p-about/about/rate-d759414056aaaca14dbd72c2afe01e74.svg";